import useMutationApi from 'src/api/useMutationApi';
import { FamousShipmentDTO } from './useFamousShipments';

const useSyncFamousShipment = (
  shipmentId: string,
  onSuccess?: (data: FamousShipmentDTO) => void,
) => {
  // `force: true` is admin-only and bypasses the post-send lock on the
  // backend (clearing the 856 sent-tracking fields so the ASN can be re-sent).
  return useMutationApi<{ force?: boolean }, FamousShipmentDTO>({
    endpoint: `famous/shipments/${shipmentId}/sync`,
    method: 'POST',
    options: {
      onSuccess: onSuccess ? (response) => onSuccess(response.data) : undefined,
    },
  });
};

export default useSyncFamousShipment;
